import $ from 'jquery';
import 'select2';

$('select:not(.no-select2)').each(function () {
    const withSearch = $(this).hasClass('select-with-search');
    const withTags = $(this).hasClass('select-can-create');
    let config = {
        width: '100%',
        minimumResultsForSearch: withSearch ? 1 : -1,
    }

    if ($(this).attr('data-custom-ajax')) {
        config.ajax = {
            url: $(this).attr('data-custom-ajax').toString(),
            dataType: 'json',
            cache: true,
            data: function (params) {
                return {
                    term: params.term || '',
                    page: params.page || 1
                };
            },
            transport: function (params, success, failure) {
                (async () => {
                    let url = new URL(params.url);
                    for (let key in params.data) {
                        url.searchParams.append(key, params.data[key]);
                    }
                    try {
                        let resp = await fetch(url);
                        let data = await resp.json();
                        success(data);
                    } catch (e) {
                        failure(e);
                    }
                })();
            }
        };
    }

    if (withTags) {
        config.tags = true;
        config.createTag = function (params) {
            return {
                id: params.term,
                text: params.term,
                isTag: true,
            }
        }
    }

    $(this).select2(config);

    //Set placeholder class for styling if the select value is empty. The default placeholder implementation by select2 removes the first option.
    setPlaceholderClass($(this));
    $(this).on('change', function () {
        setPlaceholderClass($(this));
    })
});

function setPlaceholderClass($select) {
    if ($select.val() === '') {
        $select.siblings('.select2').find('.select2-selection').addClass('select2-selection--placeholder');
    } else {
        $select.siblings('.select2').find('.select2-selection').removeClass('select2-selection--placeholder');
    }
}


$('select.select-operator').each(function () {
    const mapping = {
        1: '<i class="fa-light fa-greater-than"></i>',
        2: '<i class="fa-light fa-greater-than-equal"></i>',
        3: '<i class="fa-light fa-less-than"></i>',
        4: '<i class="fa-light fa-less-than-equal"></i>',
    };

    $(this).select2({
        width: '100%',
        minimumResultsForSearch: -1,
        templateSelection: function (data) {
            if (data.id === '') {
                return data.text;
            }
            return $(`<span>${mapping[data.id]}</span>`);
        },
        templateResult: function (state) {
            if (!state.id) {
                return state.text;
            }
            return $(`<span>${mapping[state.id]}</span>`);
        }
    });
});
